import { invalidateStoredToken } from "web/utils/system/essentials/getTokenState";

import { URL_SEND } from "web/constants/session";

const clearStorageAndRedirectToLogin = () => {
  const urlSearchParams = new URLSearchParams({
    relayState: window.location.href,
    loginOrigin: window.location.origin,
  });

  invalidateStoredToken();
  sessionStorage.clear();
  localStorage.clear();

  window.location.replace(`${URL_SEND}?${urlSearchParams.toString()}`);
};

export default clearStorageAndRedirectToLogin;
